// getShowcaseListItems.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

import getListData from '../selector/getListData.js';
import { showcaseDesktopMinimumItemAmount } from '../style/variables.js';

const defaultArray = [];

/**
 * Get showcase list
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {array} The selected showcase list.
 */
const getShowcaseListItems = createCachedSelector(
  (state, showcaseType, dataKey = 'itemIds') =>
    getListData(state, ['home', 'messages', showcaseType], dataKey),
  (state, showcaseType, dataKey = 'itemIds') =>
    getListData(state, ['home', 'messages', 'home'], dataKey),
  (state, showcaseType, dataKey = 'itemIds') => dataKey,
  (featured, home, dataKey) => {
    let result;
    if ('itemIds' === dataKey) {
      const featuredList = featured || defaultArray;
      const homeList = home || defaultArray;
      // if showcase amount is less than showcaseDesktopMinimumItemAmount, then fill up showcase with home.
      const delta = showcaseDesktopMinimumItemAmount - featuredList.length;
      if (delta > 0) {
        result = featuredList.concat(homeList.slice(0, delta));
      } else {
        result = featuredList;
      }
    } else if ('totalCount' === dataKey) {
      // if showcase amount is less than showcaseDesktopMinimumItemAmount, then fill up showcase with home.
      const featuredTotalCount = featured || 0;
      const delta = showcaseDesktopMinimumItemAmount - featuredTotalCount;
      if (delta > 0) {
        result = showcaseDesktopMinimumItemAmount;
      } else {
        result = featuredTotalCount;
      }
    }

    return result instanceof Collection ? result.toJS() : result;
  }
)(
  (state, showcaseType, dataKey = 'itemIds') =>
    `getShowcaseListItems:${showcaseType}:${dataKey}`
);

export default getShowcaseListItems;
